import { gql } from '@apollo/client'
import { Coproprietaire } from '../fragment/coproprietaire.fragment'

export const PERSONNE = gql`
  query Personne($search: String!) {
    personnes: d4_personne(
      limit: 5
      offset: 0
      where: { _and: [{ nom: { _ilike: $search }, dtype: { _eq: "Personne" } }] }
    ) {
      id
      nom
      prenom
    }
  }
`

const PersonneFragment = gql`
  fragment Personne on d4_personne {
    nom
    prenom
    id
    telfixe
    mail1
    mail2
    titre
    telportable
    comptevision {
      actif
    }
    coproprietaire {
      ...CoproprietaireLots
    }
  }
  ${Coproprietaire.fragments.coproprietaire}
`

export const PERSONNE_DETAIL_BY_ID = gql`
  query PersonneDetail($id: bigint!) {
    personneDetail: d4_personne_by_pk(id: $id) {
      ...Personne
      boitemail {
        id
      }
      adresse {
        batiment
        codepostal
        typedevoie
        complementadresse
        numerodanslavoie
        etage
        ville
        voie
      }
    }
  }
  ${PersonneFragment}
`

export const PERSONNE_DETAIL_BY_TEL = gql`
  query PersonneDetailByTel($tel: String!) {
    personneDetail: d4_personne(where: { _or: [{ telportable: { _like: $tel } }, { telfixe: { _like: $tel } }] }) {
      ...Personne
      adresse {
        batiment
        codepostal
        typedevoie
        complementadresse
        numerodanslavoie
        etage
        ville
        voie
      }
    }
  }
  ${PersonneFragment}
`

export const PERSONNE_DETAIL_BY_MAIL = gql`
  query PersonneDetailByMail($mail: String!) {
    personneDetail: d4_personne(where: { _or: [{ mail1: { _like: $mail } }, { mail2: { _like: $mail } }] }) {
      ...Personne
    }
  }
  ${PersonneFragment}
`

export const GESTIONNAIRE_QUERY = gql`
  query Gestionnaires {
    gestionnaires: d4_personne(
      where: { _and: [{ dtype: { _eq: "Gestionnaire" } }, { comptevision: { actif: { _eq: true } } }] }
    ) {
      id
      dtype
      prenom
      nom
      mail1
    }
  }
`

export const GESTIONNAIR_BY_ID = gql`
  query Gestionnaires($id: bigint!) {
    gestionnaire: d4_personne_by_pk(id: $id) {
      id
      dtype
      prenom
      nom
      mail1
    }
  }
`

export const PERSONNE_SEARCH = gql`
  query PersonneSearch($search: String, $id: bigint) {
    lots: d4_lot(
      order_by: { copropriete_id: asc }
      where: {
        _or: [
          { lot_coproprietaire: { coproprietaire: { personne: { nom: { _ilike: $search } } } } }
          { id: { _eq: $id } }
        ]
      }
    ) {
      id
      nature
      numerodelot
      lot_coproprietaire {
        coproprietaire {
          personne {
            id
            nom
            prenom
          }
        }
      }
      copropriete_id
      copropriete {
        id
        trigramme
      }
    }
  }
`

export const PERSONNE_SEARCH_BY_COPRO_QUERY = gql`
  query PersonneSearchByCopro($search: String, $id: bigint, $trigramme: String!) {
    lots: d4_lot(
      where: {
        _or: [
          {
            _and: [
              {
                _or: [
                  { lot_coproprietaire: { coproprietaire: { personne: { nom: { _ilike: $search } } } } }
                  { lot_coproprietaire: { coproprietaire: { personne: { prenom: { _ilike: $search } } } } }
                  { lot_coproprietaire: { coproprietaire: { societe: { raisonsociale: { _ilike: $search } } } } }
                ]
              }
              { copropriete: { trigramme: { _eq: $trigramme } } }
            ]
          }
          { id: { _eq: $id } }
          { lot_coproprietaire: { coproprietaire: { id: { _eq: $id } } } }
        ]
      }
    ) {
      id
      lot_coproprietaire {
        coproprietaire {
          id
          personne {
            id
            nom
            prenom
          }
          societe {
            id
            raisonsociale
          }
        }
      }
      copropriete_id
      copropriete {
        id
        trigramme
      }
    }
  }
`

export const PERSONNE_SEARCH_BY_MAIL = gql`
  query PersonneSearch($search: String!) {
    lots: d4_lot(
      distinct_on: copropriete_id
      order_by: { copropriete_id: asc }
      where: { lot_coproprietaire: { coproprietaire: { personne: { mail1: { _eq: $search } } } } }
    ) {
      id
      lot_coproprietaire {
        lot {
          batiment_id
        }
        coproprietaire {
          personne {
            id
            nom
            prenom
          }
        }
      }
      copropriete_id
      copropriete {
        id
        trigramme
      }
    }
  }
`

export const C_S_QUERY = gql`
  query CS($trg: String!) {
    d4_conseilsyndical(where: { copropriete: { trigramme: { _eq: $trg } } }) {
      id
      persident_societe {
        id
        raisonsociale
        telportable
        mail1
        coproprietaire {
          matricules {
            permalink
          }
        }
      }
      president {
        id
        nom
        telportable
        prenom
        mail1
        coproprietaire {
          matricules {
            permalink
          }
        }
      }
      membres_personne {
        membre {
          id
          nom
          prenom
          telportable
          mail1
          coproprietaire {
            matricules {
              permalink
            }
          }
        }
      }
      membres_societe {
        membre {
          id
          raisonsociale
          telportable
          mail1
          coproprietaire {
            matricules {
              permalink
            }
          }
        }
      }
    }
  }
`
